import React from 'react'
import { Drawer, Dropdown, Menu, notification, Popconfirm, Tooltip } from 'antd'
import { translations } from '../../utils/constants'
import { DownOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons'
import { Link, useLocation, Redirect } from 'react-router-dom'
import { removeToken, removeUser } from '../../Redux/actions/authActions'
import { useDispatch, useSelector } from 'react-redux'
import allPaths from '../../Config/paths'

const SideMenu = ({ setVisible, visible, language }) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const authUser = useSelector((state) => state.authReducer?.user)
    // console.log('authUser in SideMenu:', authUser)
    const onClose = () => {
        setVisible(false)
    }

    const logout = () => {
        dispatch(removeUser())
        dispatch(removeToken())
    }

    let drawerRoutes = [
        {
            title: translations[language]?.GeofencingAdmin,
            route: allPaths?.HOME,
        },
        {
            title: translations[language]?.devices,
            route: allPaths?.DEVICES,
        },
        {
            title: translations[language]?.user,
            route: allPaths?.USER,
            isAdminOnly: true
        },
        {
            title: translations[language]?.map,
            route: allPaths?.MAP,
        },
        {
            title: translations[language]?.profileSetting,
            route: allPaths?.PROFILE,
        },
    ]

    const filteredRoutes = drawerRoutes?.filter(route => {
        if (route.isAdminOnly && authUser?.role === 'user') {
            return false;
        }
        return true;
    })

    const menu = (
        <Menu>
            <Menu.Item key="logout" onClick={logout} icon={<LogoutOutlined style={{ color: '#ff4d4f' }} />}>
                {translations[language]?.Logout}
            </Menu.Item>
        </Menu>
    )

    return (
        <div className='drawer-main-div'>
            <Drawer
                title={translations[language]?.ProjectName}
                onClose={onClose}
                visible={visible}
                width={240}
                placement="left"
            >
                {filteredRoutes?.map((v, i) => {
                    const isActive = location?.pathname === v?.route
                    return (
                        <div key={i} className='drawer-main-div' style={{ padding: '8px 0' }}>
                            <Link to={v?.route}>
                                <span
                                    className='drawer-link'
                                    onClick={onClose}
                                    style={{
                                        color: isActive ? 'white' : 'black',
                                        backgroundColor: isActive ? '#ed2328' : '',
                                        padding: '8px 16px',
                                        display: 'block',
                                    }}
                                >
                                    {v.title}
                                </span>
                            </Link>
                        </div>
                    )
                })}

                {/* <div className='sidemenu-logout-btn'>
                    <span
                        onClick={logout}
                        style={{
                            padding: '8px 16px',
                            display: 'block',
                            color: '#ff4d4f',
                            cursor: 'pointer',
                            borderRadius: '4px',
                            marginTop: '10px',
                        }}
                    >
                        <LogoutOutlined /> {translations[language]?.Logout}
                    </span>

                </div> */

                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            width: '90%',
                            borderTop: '1px solid #f0f0f0',
                            padding: '12px 16px',
                            background: '#fff',
                            marginLeft: '-16px',
                        }}
                    >
                        <div
                            style={{
                                border: '1px solid #d9d9d9',
                                borderRadius: '6px',
                                padding: '8px 12px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: '8px',
                            }}
                        >

                            <Tooltip title={authUser?.username || 'User'}>
                                <span
                                    style={{
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: 'inline-block',
                                        maxWidth: 150
                                    }}
                                >
                                    <UserOutlined style={{ marginRight: 8 }} />
                                    <span>{authUser?.username || 'User'}</span>
                                </span>
                            </Tooltip>

                        </div>
                        <button
                            onClick={logout}
                            style={{
                                background: '#ed2328',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                width: '100%',
                                textAlign: 'center',
                                marginTop: '10px',
                                padding: '8px 12px',

                            }}
                        >
                            <LogoutOutlined /> {translations[language]?.Logout}
                        </button>
                    </div>

                }
            </Drawer>
        </div>
    )
}

export default SideMenu
